// AUTO-STUB — à remplacer par l'implémentation réelle
import React from 'react';
export function AISuggestionCard(_props: any): React.ReactElement | null {
  return null;
}
export default AISuggestionCard;
